import { Button, DialogActions, IconButton, Stack, Tooltip, Typography, Menu, MenuItem } from '@mui/material';
import React from 'react';
import Datatable from '../../../../components/DataTable';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import moment from 'moment';
import PageHeader from '../../../../components/PageHeader';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import AddNoonReport from './AddNoonReport';
import ViewNoonReport from './ViewNoonReport';
import { useEffect } from 'react';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { CancelToken } from 'apisauce';
import appapi from '../../../../api/apiClient';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { checkPermission } from '../../../../redux/features/authSlice';
import AccessDenied from '../../AccesDenied/AccessDenied';
import Edit from '../../../../assets/images/editReport.svg';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

export default function Reports({ voyageDetails, data }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const [list, setList] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [showSelectedReport, setShowSelectedReport] = useState(false);
  const [showSelectedEditReport, setShowSelectedEditReport] = useState(false);
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noonReportList, setNoonReportList] = useState([]);
  const [isBossShip, setIsBossShip] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(false);
  const [anchorE2, setAnchorE2] = useState(false);
  const open = Boolean(anchorEl);

  const voyagePermission = useSelector((state) => checkPermission(state, 'Fleet Management', 'Manage Noon Reports'));

  const { t } = useTranslation();
  const {
    i18n: { language },
  } = useTranslation();

  const [openAddNoonReport, setOpenAddNoonReport] = useState(false);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setIsDropdownOpen(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setIsDropdownOpen(false);
  };

  const [payload, setPayload] = useState({
    page: 1,
    limit: 50,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    companyTypeFilter: [],
    field: '_id',
    sortOrder: 'desc',
  });

  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1, filter: search }));
  };

  let source = CancelToken.source();
  let source2 = CancelToken.source();

  useEffect(() => {
    setList(
      noonReportList.map((res, index) => {
        return {
          ...res,
          Sno: index + 1,
          isSelected: false,
        };
      }),
    );
  }, [noonReportList]);

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    setSelectedReport(checkedStatus ? item : null);
  };

  useEffect(() => {
    if (list.length > 0) {
      if (selectedReport) {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: res._id === selectedReport._id,
          };
        });
        setList(items);
      } else {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: false,
          };
        });
        setList(items);
      }
    }
  }, [selectedReport]);

  const getNoonReportList = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `fleet/noonReportList/${data?._id}`,
      {
        pageNumber: payload.page,
        pageSize: payload.limit,
        filter: payload.filter ? payload.filter : null,
      },
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
       
        setNoonReportList(data.response?.response);
        setIsBossShip(data?.response?.isBossShip);
      }
      setLoading(false);
    }
  };

  const initApi = async () => {
    await getNoonReportList();
  };

  useEffect(() => {
    if (data && voyagePermission.viewAccess) {
      initApi();
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [data, payload.filter]);

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '10%',
    },

    {
      id: 1,
      header: 'Report date',
      accessor: 'reportDate',
      width: '20%',
      Cell: (value) => (
        <Stack>
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {moment(value?.reportDate).tz('utc').format('DD-MMM-YYYY') || '-'}
          </Typography>
        </Stack>
      ),
    },

    {
      id: 2,
      header: 'Total FOC',
      accessor: 'cumulativeFOC',
      width: '15%',
      capitalize: true,
    },

    {
      id: 4,
      header: 'Applicable CO2',
      accessor: 'applicableCO2',
      width: '20%',
    },
    {
      id: 5,
      header: 'Status',
      accessor: 'voyageStatus',
      width: '30%',
    },
  ];

  const handleExcelDownload = async (format) => {
    const response = await appapi.get(`/fleet/excelnoonReport/${voyageDetails?._id}`, {}, { responseType: 'blob' });
    if (response.ok) {
      try {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        const ext = format === 'csv' ? 'csv' : 'xlsx';
        link.download = `NOONREPORTS${new Date().getTime()}.${ext}`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading:', error);
      }
    } else {
    }
  };

  const handleValidatedExcelDownload = async (format) => {
    const response = await appapi.get(`/fleet/excelBoosValidatedNoonReport/${voyageDetails?._id}`, {}, { responseType: 'blob' });
    if (response.ok) {
      try {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        const ext = format === 'csv' ? 'csv' : 'xlsx';
        link.download = `NOONREPORTS${new Date().getTime()}.${ext}`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading:', error);
      }
    } else {
    }
  };

  const getReportDetails = async () => {
    // setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `fleet/noonReport/${selectedReport?._id}`,
      {},
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setDetails(data.response);
        setShowSelectedEditReport(true);
      }
      setLoading(false);
    }
  };

  console.log(isBossShip,"bosssssssss")

  return voyagePermission.viewAccess ? (
    <Stack
      flex={1}
      className="flex-overflow"
    >
      <PageHeader
        tableType={'2'}
        handleOnSearchEmit={(search) => {
          handleSearchEmit(search);
        }}
      >
        <Stack
          direction="row"
          alignItems={'center'}
        >
          <Stack style={{ paddingLeft: '10px', marginRight: '10px' }}>
            <Typography
              className="fs-14 ff-Roboto fw-medium !capitalize"
              color={text}
            >
              {t('Noon reports')}
            </Typography>
          </Stack>
          <Tooltip
            title={t('View Report')}
            placement="top"
          >
            <IconButton
              onClick={() => setShowSelectedReport(true)}
              flex={0.2}
              disabled={!Boolean(selectedReport)}
            >
              <MenuBookIcon
                color="#8993AC"
                style={{ width: '16px', height: '16px' }}
              />
            </IconButton>
          </Tooltip>

          <Tooltip
            title={t('Edit Report')}
            placement="top"
          >
            <IconButton
              onClick={() => getReportDetails()}
              flex={0.2}
              disabled={!Boolean(selectedReport)}
            >
              <img
                src={Edit}
                width={'14px'}
                height={'14px'}
                disabled={!Boolean(selectedReport)}
              />
            </IconButton>
          </Tooltip>
        </Stack>
      </PageHeader>
      <Stack
        flexGrow={1}
        className="mt-[10px] relative flex-auto overflow-auto"
      >
        <Datatable
          tableHeadBgColor={'#e6f1ff'}
          columns={columns}
          data={list}
          isLoading={loading}
          showCheckBox={true}
          onChangeCheckBox={handleOnChangeCheckBox}
        />
      </Stack>
      <Stack flexGrow={1}></Stack>
      <DialogActions
        className="h-[66px] !justify-between p-[0px] sticky bottom-[0]"
        style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
      >
        <Button
          disabled={list.length <= 0}
          // sx={[
          //   dialogButtonCancel,
          //   {
          //     color: theme.palette.primary.main,
          //     textTransform: 'uppercase',
          //     '&:hover': {},
          //   },
          // ]}
          sx={{
            border: 1,
            margin: '10px',
            color: theme.palette.primary.main,
            borderColor: '#14285A4D',
            backgroundColor: '#FFFFFF',
            textTransform: 'uppercase',
            '&:hover': {
              borderColor: '#14285A4D',
              backgroundColor: '#FFFFFF',
              borderColor: '#14285A4D',
            },
          }}
          style={{ width: '178px', height: '40px' }}
          onClick={handleMenuOpen}
        >
          {t('Generate report')}
          {isDropdownOpen ? <ArrowDropUpIcon style={{ color: theme.palette.grey.main, fontSize: '28px' }} /> : <ArrowDropDownIcon style={{ color: theme.palette.grey.main, fontSize: '28px' }} />}
        </Button>
        <Menu
          className="appbar"
          id="resource-menu"
          anchorEl={anchorEl}
          open={open}
          MenuListProps={{
            'aria-labelledby': 'resource-button',
          }}
          onClose={handleMenuClose}
          PopperProps={
            {
              // placement: 'top-start',
            }
          }
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          PaperProps={{
            style: {
              width: '217px',
              marginTop: '5px',
            },
          }}
        >
          <MenuItem
            className="ff-Roboto fs-12 fs-medium"
            style={{ minHeight: '32px' }}
            onClose={handleMenuClose}
            onClick={() => {
              handleExcelDownload();
              handleMenuClose();
            }}
          >
            {t('Noon Report')}
          </MenuItem>
          {isBossShip && (
            <MenuItem
              className="ff-Roboto fs-12 fs-medium"
              style={{ minHeight: '32px' }}
              onClose={handleMenuClose}
              onClick={() => {
                handleValidatedExcelDownload();
                handleMenuClose();
              }}
            >
              {t('Validated Noon Report')}
            </MenuItem>
          )}
        </Menu>
        <Button
          sx={{
            border: 1,
            margin: '10px',
            color: theme.palette.primary.text,
            borderColor: '#14285A4D',
            backgroundColor: '#FFFFFF',
            textTransform: 'uppercase',
            '&:hover': {
              borderColor: '#14285A4D',
              backgroundColor: '#FFFFFF',
              borderColor: '#14285A4D',
            },
            minWidth: language === 'en' ? '170px' : '230px',
          }}
          style={buttonStyle2}
          variant="contained"
          onClick={() => {
            setOpenAddNoonReport(true);
          }}
        >
          {t('Add noon report')}
        </Button>
      </DialogActions>

      {showSelectedReport && (
        <ViewNoonReport
          modelOpen={setShowSelectedReport}
          onModelHandleClose={(event) => {
            setShowSelectedReport(false);
            getNoonReportList();
          }}
          data={selectedReport}
          voyageDetails={voyageDetails}
        />
      )}
      {openAddNoonReport && (
        <AddNoonReport
          modelOpen={openAddNoonReport}
          onModelHandleClose={(event) => {
            if (event) {
              setOpenAddNoonReport(false);
              getNoonReportList();
            }
            setOpenAddNoonReport(false);
          }}
          voyageDetails={voyageDetails}
        />
      )}

      {showSelectedEditReport && (
        <AddNoonReport
          modelOpen={showSelectedEditReport}
          onModelHandleClose={(event) => {
            if (event) {
              setShowSelectedEditReport(false);
              getNoonReportList();
            }
            setShowSelectedEditReport(false);
          }}
          voyageDetails={voyageDetails}
          data={details}
          loading={loading}
        />
      )}
    </Stack>
  ) : (
    <AccessDenied />
  );
}
